import { getScrollPosition } from './scroll-position.js';

export interface ElementPosition {
    top: number;
    left: number;
    right: number;
    bottom: number;
    width: number;
    height: number;
}

/**
 * gets absolute position of element, independent of scrolled viewport.
 *
 * @param element element to get position of
 * @returns absolute position of element
 */
export const getElementPosition = (element: Element): ElementPosition => {
    const { top, left, bottom, right, width, height } = element.getBoundingClientRect();

    //make sure to use window object which the element actually resides in
    const { scrollTop, scrollLeft } = getScrollPosition(element.ownerDocument?.defaultView || window);
    return {
        top: Math.round(top) + scrollTop,
        left: Math.round(left) + scrollLeft,
        bottom: Math.round(bottom) + scrollTop,
        right: Math.round(right) + scrollLeft,
        width: Math.round(width),
        height: Math.round(height),
    };
}
